import React from 'react';

import { globalConstants } from '@/shared/duck';

import { GlobalContext } from '.';

const GlobalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentPage, setCurrentPage] = React.useState<string>(globalConstants.PAGES.discover);
  const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(false);
  const [footerHeight, setFooterHeight] = React.useState<number>(0);

  const initialValues = {
    currentPage,
    setCurrentPage,
    isLoggedIn,
    setIsLoggedIn,
    footerHeight,
    setFooterHeight,
  };

  return (
    <GlobalContext.Provider value={initialValues}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;